class Content extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.display = 'flex';
    this.className = this.getAttribute('class') || this.getAttribute('className');
    // this.updateContent();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === 'className' || name === 'class') && (oldValue !== newValue)) {
      this.className = newValue;
    }
  }

  static get observedAttributes() {
    return ['className', 'class'];
  }

  // updateContent() {
  //   if (this.getAttribute('content')) {
  //     this.textContent = this.getAttribute('content');
  //   } else {
  //     const slot = this.querySelector('slot');
  //     if (!slot) {
  //       const newSlot = document.createElement('slot');
  //       this.appendChild(newSlot);
  //     }
  //   }
  // }
}

export default Content;